

































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Views, ViewModes } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import EntitySocialMethods from '@/mixins/EntitySocialMethods.vue';
import CloseButton from '@/components/Buttons/CloseButton.vue';
import EventCardSocials from '@/components/NewsFeed/Components/Partials/Events/EventCardSocials.vue';
import ProfileImage from '@/components/Media/ProfileImage.vue';
import DashboardNotification from '@/ts/instances/notifications/DashboardNotification';

@Component({
    components: {
        CloseButton,
        EventCardSocials,
        ProfileImage,
    },
})
export default class EventFeedView extends Mixins(DateMethods, EntitySocialMethods) {
    public buttonState: boolean = false;
    public notificationIsLoaded: boolean = false;

    constructor() {
        super();

        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
    }

    get media() {
        return this.notificationIsLoaded ? this.$store.getters['Notifications/getNotificationMedia'](this.notification.id) : null;
    }

    get notification(): DashboardNotification {
        return this.$store.getters['TenantNotifications/getActiveNotification'];
    }

    get attendingBtnText(): string {
        return !this.notification.attendingStatus ? this.$t('general.attend', 'Attend') : this.$t('general.attending', 'Attending');
    }

    get attendingDeclinedBtnText() {
        return this.notification.attendingStatus === false ? this.$t('general.declined', 'Declined') : this.$t('general.decline', 'Decline');
    }

    public changeAttendingStatus(value: boolean) {
        if (value === this.notification.attending) {
            return;
        }

        this.buttonState = true;
        const eventId    = this.notification.eventId;

        this.$store.dispatch(Actions.POST_USER_ATTENDING_CALENDAR_EVENT, {
            eventId,
            attending: value,
        }).then(() => {
            this.notification.changeAttendeesList(value);
            this.buttonState = false;
        });
    }

    public fetchNotificationMedia(): void {
        this.$store.dispatch(Actions.FETCH_NOTIFICATION_MEDIA_FOR_USER, this.notification.id);
    }

    public close() {
        this.$router.back();
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_TENANT_NOTIFICATION, this.$route.query.notification)
            .then(() => {
                this.notificationIsLoaded = true;

                if (this.notification.hasMedia) {
                    this.fetchNotificationMedia();
                }
            });
    }

    public destroyed() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Notifications,
            viewMode: ViewModes.Notifications.All,
        });

        this.$store.commit(Mutations.SET_TENANT_ACTIVE_NOTIFICATION, null);
        this.notificationIsLoaded = false;
    }
}
